import axios from 'axios'
import { FRIENDLY_DATETIME_FORMAT } from '@/config/dateUtils'
import FileService from '@/services/FileService'
import BaseService from './BaseService'
import entities from 'src/config/entities'

class JobAlertService extends BaseService {
  constructor () {
    super({entity: entities.JOB_ALERT})
  }

  async export(data) {
    try {
      let res = await axios.post(`job-alerts/export`, data, {
        responseType: 'blob'
      })

      let fileName = `job-alerts-${format(new Date(), FRIENDLY_DATETIME_FORMAT)}.csv`
      FileService.downloadFileInBrowser(res, fileName)
    } catch (e) {
      this._handleError({ translationKey: 'jobAlerts.messages.exportError', error: e });
      throw e;
    }
  }

}

export default new JobAlertService()
